import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';

const ProtectedRoute: React.FC = () => {

    //Check current session
    const isSessionValid = (): boolean => {
        const token = Cookies.get('token');
        const tokenExpiry = Cookies.get('tokenExpiry');

        if (!token || !tokenExpiry) {
            return false;
        }

        return new Date().getTime() < parseInt(tokenExpiry, 10);
    };

    if (!isSessionValid()) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;